<template>
  <div class="camera-error-layout--container">
    <div>
      <div class="camera-error-layout--header">
        <slot name="header" />
      </div>
      <div class="camera-error-layout--content">
        <slot name="content" />
      </div>
    </div>

    <div class="camera-error-layout--footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'v2-camera-error-layout',
};
</script>

<style lang="scss" scoped>
  .camera-error-layout--container {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
  }

  .camera-error-layout--header, .camera-error-layout--footer {
    padding: 24px;
  }

  .camera-error-layout--content {
    padding: 0 24px;
  }
</style>
